

<app-page-header [title]="'Create Bot'" [backLink]="['/createbot']"></app-page-header>

<nz-card style="width: 100%;" [nzBordered]="false" >
  <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm">
    <nz-row nzGutter="24">

      <!-- Form Column (Scrollable) -->
      <nz-col [nzSpan]="15" style="height: 100vh; overflow-y: auto; padding-right: 10px;">

        <!-- <div nz-row [nzGutter]="8" class="brand-details-container"> -->
          <!-- First Column -->
          <!-- <div *ngIf="role==='admin'" nzValue="reseller" nz-col [nzSpan]="8">
            <nz-form-control>
              <nz-form-label for="Reseller"> Select Reseller</nz-form-label>
              <nz-select id="Reseller" nzPlaceHolder="Select a user" [(ngModel)]="selectedReseller"
                [ngModelOptions]="{standalone: true}" (ngModelChange)="onResellerChange($event) "
                [(ngModel)]="selectedReseller">
                <nz-option *ngFor="let reseller of ResllerList" [nzValue]="reseller.label"
                  [nzLabel]="reseller.label"></nz-option>
              </nz-select>
            </nz-form-control>
          </div>
          <div *ngIf="role==='reseller' || role==='admin'" nz-col [nzSpan]="8">
            <nz-form-control>
              <nz-form-label for="Seller"> Select Seller</nz-form-label>
              <nz-select id="Seller" nzPlaceHolder="Select a user" [(ngModel)]="selectedSeller"
                [ngModelOptions]="{standalone: true}" (ngModelChange)="onSellerChange($event)"
                [(ngModel)]="selectedSeller">
                <nz-option *ngFor="let seller of SellerList" [nzValue]="seller.label"
                  [nzLabel]="seller.label"></nz-option>
              </nz-select>
            </nz-form-control>
          </div>
          <div *ngIf="role==='seller' || role==='reseller' || role==='admin'" nz-col [nzSpan]="8">
            <nz-form-control>
              <nz-form-label for="Client"> Select Client</nz-form-label>
              <nz-select id="Client" nzPlaceHolder="Select a user" [(ngModel)]="selectedClient"
                [ngModelOptions]="{standalone: true}" (ngModelChange)="onClientChange($event)"
                [(ngModel)]="selectedClient">
                <nz-option *ngFor="let Client of Clientlist" [nzValue]="Client.label"
                  [nzLabel]="Client.label"></nz-option>
              </nz-select>
            </nz-form-control>
          </div> -->
        <!-- </div> -->
        <app-filter-dropdown [role]="role" (selectionChange)="handleSelection($event)"></app-filter-dropdown>
        <div class="" nz-row nzGutter="12" style="margin-top: 20px;">
          <div nz-col [nzSpan]="12" class="form-group">
            <nz-form-item nz-row>
              <nz-form-label nzRequired nzLabelAlign="left" for="brandName">
                Brand Name
              </nz-form-label>
              <nz-form-control>
                <nz-select id="brandName" formControlName="brandName" nzPlaceHolder="Select a Brand">
                  <nz-option *ngFor="let brand of brandDataList" [nzValue]="brand.brandName"
                    [nzLabel]="brand.brandName"></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="botName">Bot Name</nz-form-label>

              <nz-form-control [nzErrorTip]="botNameError">

                <input nz-input id="botName" formControlName="botName" id="botName" style="width: 100%;"
                  placeholder="bot Name" (blur)="isBotExisting($event)" />
                    
                </nz-form-control>
                <!-- <small style="display: flex; justify-content: end;">{{validateForm.get('botName')?.value?.length || 0}}/21</small> -->
              <ng-template #botNameError>
                <div *ngIf="validateForm.get('botName')?.hasError('required')">
                  Bot name is required.
                </div>
                <div *ngIf="validateForm.get('botName')?.hasError('pattern')">
                  Bot name should only contain letters, numbers, and underscores.
                </div>
                <div *ngIf="validateForm.get('botName')?.hasError('existingBot')">
                  Bot name already exists.
                </div>
                <div *ngIf="validateForm.get('botName')?.hasError('maxlength')">
                  Bot name cannot exceed 21 characters.
                </div>

              </ng-template>
            </nz-form-item>
          </div>
        </div>


        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzRequired nzFor="region">
            Region
          </nz-form-label>
          <nz-form-control [nzSm]="17" [nzXs]="24" nzErrorTip="Please select a region">
            <nz-radio-group nzName="radiogroup" formControlName="region">
              <label nz-radio nzValue="India">
                India <i nz-icon style="color: #ff0909;" nzType="info-circle" class="info-icon" nz-tooltip
                  nzTooltipTitle="The bot will be sending traffic only to India. It will not be live in other countries."></i>
              </label>
              <!-- <label nz-radio nzValue="US">
                Rest of World <i nz-icon style="color: #ff0909;" nzType="info-circle" class="info-icon" nz-tooltip
                  nzTooltipTitle="The bot will be sending traffic only outside India. It will not be live in India."></i>
              </label> -->
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>


        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzRequired nzFor="messageType">Bot Message Type</nz-form-label>
          <nz-form-control [nzSm]="17" [nzXs]="24" nzErrorTip="message type">
            <nz-radio-group nzName="radiogroup" formControlName="messageType">
              <label nz-radio nzValue="Promotional">Promotional</label>
              <label nz-radio nzValue="OTP">OTP</label>
              <!-- <label nz-radio nzValue="Multi-Use">Multi-Use</label> -->
              <label nz-radio nzValue="Transactional">Transactional</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzRequired nzFor="to">Bot Billing category</nz-form-label>
          <nz-form-control [nzSm]="17" [nzXs]="24" nzErrorTip="Mobile number required!">
            <nz-select size="medium" nzPlaceHolder="Please select" formControlName="billingCategory"
              [nzAutoClearSearchValue]="false">
              <nz-option nzValue="Conversational" nzLabel="Conversational"></nz-option>
              <nz-option nzValue="nonconversational" nzLabel="Non Conversational"></nz-option>
            </nz-select>

          </nz-form-control>
        </nz-form-item>





        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="12" nzRequired>Bot Logo</nz-form-label>
          <p>Provide a logo for your bot that will be displayed in connection with the bot's name</p>
          <nz-form-control [nzSm]="10" [nzXs]="12" nzErrorTip="Bot Logo!">
            <div class="" style="display: flex; flex-direction: column; align-items: center; gap: 10px;">
              <img src="assets\images\size-bot.png" *ngIf="!imageUrl" alt="" style="width: 150px; height: 150px;">
              <div *ngIf="imageUrl" class="preview-container">

                <img [src]="imageUrl" alt="Bot Logo Preview" class="image-preview" style="border-radius: 100%;" />
              </div>
              <button nz-button nzType="primary" (click)="showModal()">
                <span>Upload</span>
              </button>
            </div>
            <nz-modal [(nzVisible)]="isVisible" [nzTitle]="modalTitle1" [nzContent]="modalContent1"
              [nzFooter]="modalFooter1" (nzOnCancel)="handleCancel()">
              <ng-template #modalTitle1>Select An Image</ng-template>
              <ng-template #modalContent1>
                <nz-tabset>
                  <nz-tab nzTitle="Upload Image">
                    <p>The image you upload must be 224 pixels wide x 224 pixels tall, have a max file size of 90KB, and
                      be a JPEG, JPG, and PNG. IF the image you select doesn’t meet these requirements, you’ll have the
                      opportunity to edit it.</p>

                    <span style="color: red;">{{err}}</span>
                    <nz-upload *ngIf="!selectedFile1" nzType="drag" [nzMultiple]="false"
                      (nzChange)="onFileupload($event ,'logo')" [nzShowUploadList]="false" style="width: 100%;"
                      nzAccept=".jpeg, .jpg, .png">
                      <p class="ant-upload-drag-icon">
                        <i nz-icon nzType="inbox"></i>
                      </p>
                      <p class="ant-upload-text">Click or drag an image here to upload</p>
                      <p class="ant-upload-hint">Only JPEG, JPG, and PNG files under 90KB are allowed.</p>
                    </nz-upload>
                    <app-upload-modal
                        *ngIf="selectedFile1"
                        [imageFile]="selectedFile1"
                        [cropWidth]="224"
                        [cropHeight]="224"
                        (cropped)="onImageCropped($event)">
                        </app-upload-modal>

                  </nz-tab>
                  <!-- <nz-tab nzTitle="Upload By Link">
                    <p>The image you upload must be 224 pixels wide x 224 pixels tall, have a max file size of 90KB, and be a JPEG, JPG or PNG. IF the image you select doesn’t meet these requirements, you’ll have the opportunity to edit it.</p>
                    <p>Upload Image by link</p>
                    <input type="text" nz-input placeholder="Enter Image URL" />
                    <button nz-button nzType="primary">Upload</button>
                  </nz-tab> -->
                </nz-tabset>
              </ng-template>
              <ng-template #modalFooter1>
                <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
                <button nz-button nzType="primary" (click)="handleOk()" [nzLoading]="isConfirmLoading">Submit</button>
              </ng-template>
            </nz-modal>
          </nz-form-control>
        </nz-form-item>


        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="12" nzRequired>Banner Image</nz-form-label>
          <p>Provide a brand Image for your bot to be displayed in the bot 'info & options' screen</p>
          <nz-form-control [nzSm]="10" [nzXs]="12" nzErrorTip="Bot Logo!">
            <div class="" style="display: flex; flex-direction: column; align-items: center; gap: 10px;">
              <img src="assets\images\size-brand.png" *ngIf="!backgroundUrl" alt=""
                style="width: 200px; height: 150px;">
              <div *ngIf="backgroundUrl" class="preview-container">

                <img [src]="backgroundUrl" alt="Bot Logo Preview" class="image-preview" />
              </div>
              <button nz-button nzType="primary" (click)="showModal1()">
                <span>Upload</span>
              </button>
            </div>
            <nz-modal [(nzVisible)]="isVisible1" [nzTitle]="modalTitle" [nzContent]="modalContent"
              [nzFooter]="modalFooter" (nzOnCancel)="handleCancel1()">
              <ng-template #modalTitle>Select An Image</ng-template>
              <ng-template #modalContent>
                <nz-tabset>
                  <nz-tab nzTitle="Upload Image">
                    <p>The image you upload must be 1440 pixels wide x 448 pixels tall, have a max file size of 360KB,
                      and be a JPEG, JPG, and PNG. IF the image you select doesn’t meet these requirements, you’ll have
                      the opportunity to edit it.</p>
                      <span style="color: red;">{{err}}</span>
                    <nz-upload *ngIf="!selectedFile1" nzType="drag" [nzMultiple]="false"
                      [nzShowUploadList]="false" style="width: 100%;" (nzChange)="onFileupload($event , 'banner')"
                      nzAccept=".jpeg, .jpg, .png">
                      <p class="ant-upload-drag-icon">
                        <i nz-icon nzType="inbox"></i>
                      </p>
                      <p class="ant-upload-text">Click or drag an image here to upload</p>
                      <p class="ant-upload-hint">Only JPEG, JPG, and PNG files under 360KB are allowed.</p>
                    </nz-upload>
                    <!-- <span *ngIf="imageChangedEvent" [ngStyle]="{ 'color': (imagewidth === 1440 && imageheight === 448) ? 'green' : 'red' }">
                      The current cropped size of the image is {{ imagewidth }} x {{ imageheight }}
                    </span>
                    <br/>
                    <span *ngIf="imageChangedEvent && imagewidth != 1440 && imageheight != 448">*Please adjust the cropper to make the image of proper 1440 x 448 </span> -->
                    <app-upload-modal
                        *ngIf="selectedFile1"
                        [imageFile]="selectedFile1"
                        [cropWidth]="1440"
                        [cropHeight]="448"
                        (cropped)="onImageCropped($event)">
                        </app-upload-modal>
                    
                  </nz-tab>
                  <!-- <nz-tab nzTitle="Upload By Link"> -->
                  <!-- <p>The image you upload must be 224 pixels wide x 224 pixels tall, have a max file size of 90KB, and be a JPEG, JPG or PNG. IF the image you select doesn’t meet these requirements, you’ll have the opportunity to edit it.</p>
                    <p>Upload Image by link</p>
                    <input type="text" nz-input placeholder="Enter Image URL" />
                    <button nz-button nzType="primary">Upload</button> -->
                  <!-- <app-upload-modal></app-upload-modal> -->
                  <!-- </nz-tab> -->

                </nz-tabset>
              </ng-template>

              <ng-template #modalFooter>
                <button nz-button nzType="default" (click)="handleCancel1()">Cancel</button>
                <button nz-button nzType="primary" (click)="handleOk1()" [nzLoading]="isConfirmLoading">Submit</button>
              </ng-template>
            </nz-modal>

            <!-- <div *ngIf="backgroundUrl" class="preview-container">
              <p>Banner Preview:</p>
              <img [src]="backgroundUrl" alt="Banner Preview" class="image-preview" />
            </div> -->
          </nz-form-control>


        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzRequired nzFor="to">Bot Summary</nz-form-label>
          <nz-form-control [nzSm]="17" [nzXs]="24" nzErrorTip="bot summary required!">
            <nz-textarea-count [nzMaxCharacterCount]="100">
              <textarea nz-input formControlName="botSummary" placeholder="Controlled autosize" maxlength="100"
                placeholder="Autosize height with minimum and maximum number of lines"
                [nzAutosize]="{ minRows: 3, maxRows: 5 }">
            </textarea>
            </nz-textarea-count>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzFor="color">Select Color</nz-form-label>
          <nz-form-control [nzSm]="17" [nzXs]="24">
            <div style="display: flex; align-items: center; gap: 10px;">
              <!-- Color Picker -->
              <input type="color" id="color" formControlName="color" [(ngModel)]="selectedColor"
                class="color-picker-input" (input)="updateColorCode($event)" />
              <!-- Color Code Input -->
              <input formControlName="color" type="text" class="color-code-input" [(ngModel)]="selectedColor"
                (input)="updateColorCode($event)" maxlength="7" />
              <!-- <nz-color-picker nzShowText></nz-color-picker> -->
            </div>
            <!-- Accessibility Message -->
            <p style="font-size: 12px; color: gray; margin-top: 5px;">
              Specify a color for your agent with a minimum 4.5:1 contrast ratio relative to white.
              <a href="https://webaim.org/resources/contrastchecker/" target="_blank"
                style="color: #007bff; text-decoration: none;">Learn more</a>
            </p>
          </nz-form-control>
        </nz-form-item>




        <div nz-row [nzGutter]="24" class="brand-details-container">
          <!-- First Column -->
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="phone">Primary Phone Number</nz-form-label>
              <nz-form-control [nzErrorTip]="phoneErrorTpl">
                <nz-input-group [nzAddOnBefore]="prefixTemplate">
                  <ng-template #prefixTemplate>
                    <span>+91</span>
                  </ng-template>
                  <input nz-input formControlName="primaryphone" id="phonenumber"
                  style="width: 100%;" placeholder="Phone Number" maxlength="10" />
                </nz-input-group>
                <ng-template #phoneErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">Phone number is required</ng-container>
                  <ng-container *ngIf="control.hasError('pattern')">Phone number is invalid</ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Second Column -->
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="phone">Label for primary phone number</nz-form-label>
              <nz-form-control>
               
                  <input nz-input id="phonenumber-label" formControlName="labelphone" [value]="selectedCountryCode"
                  style="width: 100%;" placeholder="Label for Phone Number" />
                
                
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div nz-row [nzGutter]="24" class="brand-details-container">
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="phone">Primary email id</nz-form-label>
              <nz-form-control>
                <input nz-input placeholder="Primary Email Id" formControlName="primaryemail" />
              </nz-form-control>
            </nz-form-item>
          </div>
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="phone">Label for primary email id</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="emailLabel" style="width: 100%;"
                  placeholder="Label for primary email id" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row [nzGutter]="24" class="brand-details-container">
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="phone">Primary website</nz-form-label>
              <nz-form-control [nzErrorTip]="websiteErrorTpl">
                <nz-input-group [nzAddOnBefore]="prefixTemplateweb">
                  <ng-template #prefixTemplateweb>
                    <span>https://</span>
                  </ng-template>
                  <input nz-input formControlName="primarywebsite" placeholder="Primary website" />
                </nz-input-group>
                <ng-template #websiteErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">Primary website is required</ng-container>
                  <ng-container *ngIf="control.hasError('pattern')">Primary website is invalid</ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Second Column -->
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="phone">Label for primary website</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="labelwebsite" placeholder="Label for primary website" />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div nz-row [nzGutter]="24" class="brand-details-container">
          <!-- First Column -->
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="phone">Terms of Use URL</nz-form-label>
              <nz-form-control [nzErrorTip]="termErrorTpl">
                <nz-input-group [nzAddOnBefore]="prefixTemplateterms">
                  <ng-template #prefixTemplateterms>
                    <span>https://</span>
                  </ng-template>
                  <input nz-input formControlName="Url" placeholder="Terms of Use URL"  />
                </nz-input-group>
                <ng-template #termErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">Primary website is required</ng-container>
                  <ng-container *ngIf="control.hasError('pattern')">Primary website is invalid</ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Second Column -->
          <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="phone">Privacy Policy URL</nz-form-label>
              <nz-form-control [nzErrorTip]="privacyErrorTpl">
                <nz-input-group [nzAddOnBefore]="prefixTemplateprivacy">
                  <ng-template #prefixTemplateprivacy>
                    <span>https://</span>
                  </ng-template>
                  <input nz-input placeholder="Privacy Policy URL" formControlName="privacypolicyurl" />
                </nz-input-group>
                <ng-template #privacyErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">Primary website is required</ng-container>
                  <ng-container *ngIf="control.hasError('pattern')">Primary website is invalid</ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <div nz-row [nzGutter]="24" class="brand-details-container">
          <!-- First Column -->
          <!-- <div nz-col [nzSpan]="12">
                      <nz-form-item>
                        <nz-form-label nzRequired nzFor="phone">RCS API</nz-form-label>
                        <nz-form-control>
                            <nz-select [(ngModel)]="selectedApi"  [nzPlaceHolder]="'Select API'" style="width: 100%;">
                                <nz-option nzValue="Google API" nzLabel="Google API"></nz-option>
                                <nz-option nzValue="GSMA API" nzLabel="GSMA API"></nz-option>
                              </nz-select>
                              
                        </nz-form-control>
                      </nz-form-item>
                    </div> -->

          <!-- Second Column -->
          <!-- <div nz-col [nzSpan]="12">
            <nz-form-item>
              <nz-form-label nzRequired nzFor="phone">Chatbot Webhook</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="chatbotwebhook" placeholder="Chatbot Webhook" />
              </nz-form-control>
            </nz-form-item>
          </div> -->
        </div>
        <nz-form-item>
          <nz-form-label [nzSm]="7" [nzXs]="24" nzRequired nzFor="language">Languages Supported</nz-form-label>
          <nz-form-control [nzSm]="17" [nzXs]="24" nzErrorTip="Languages Supported!">
            <input nz-input id="language" formControlName="language" />
          </nz-form-control>
        </nz-form-item>






      </nz-col>


      <nz-card nz-col [nzSpan]="9" style="
      position: sticky;
      top: 0;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;">

        <app-bot-previwe [botName]="validateForm.get('botName')?.value"
          [botSummary]="validateForm.get('botSummary')?.value" [imageUrl]="imageUrl" [backgroundUrl]="backgroundUrl"
          [validateForm]="validateForm" [selectedColor]="selectedColor"
          ></app-bot-previwe>
      </nz-card>






    </nz-row>

    <div   >
      <!-- *ngIf="role !== 'client' && role !== 'reseller' && role !== 'seller'" -->
      <nz-card style="margin-top: 20px; margin-bottom: 20px;" nzTitle="Operator & Routing">
       <form [formGroup]="operatorForm">

          <!-- Select Operator -->
          <nz-form-item>
            <nz-form-label [nzSm]="7" [nzXs]="24" nzRequired nzFor="operators">Select Operator</nz-form-label>
            <nz-form-control [nzSm]="12" [nzXs]="18" nzErrorTip="Please select an operator">
              <nz-select formControlName="selectedOperators" nzMode="multiple" style="width: 100%;"
                (ngModelChange)="onOperatorChange($event)" nzPlaceHolder="select operator">
              <nz-option *ngFor="let op of operators" [nzValue]="op.name" [nzLabel]="op.label"></nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>

          <!-- Dynamic Form Array for Operators -->
          <div formArrayName="operatorData">
            <div *ngFor="let operator of operatorData.controls; let i = index" [formGroupName]="i">


              <nz-card [nzTitle]="operator.get('operatorName')?.value">
                <div nz-row [nzGutter]="8" style="display: flex; flex-wrap: wrap; align-items: center; gap:10px">
                  <nz-form-item nz-col [nzSpan]="5"
                    *ngIf="(operator.get('operatorName')?.value)">

                    <nz-form-control >
                      <nz-radio-group formControlName="isNewBot">
                        <label nz-radio [nzValue]="true">New Bot</label>
                        <label nz-radio [nzValue]="false">Existing Bot</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>
                  <nz-form-item nz-col [nzSpan]="3">
                    <nz-form-label nzFor="operatorBotId">Traffic Volume</nz-form-label>
                    <nz-form-control>
                      <nz-select formControlName="trafficVolume" nzPlaceHolder="Select Traffic Volume"
                        style="width: 100%;" [ngModel]="100">
                        <nz-option *ngFor="let volume of [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" [nzValue]="volume"
                          [nzLabel]="volume + '%'"></nz-option>
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>

                  
                   <nz-form-item nz-col [nzSpan]="5"
                    *ngIf="operator.get('isNewBot')?.value === false && ['VODAFONE','Vi'].includes(operator.get('operatorName')?.value)">
                    <nz-form-label nzFor="operatorTemplateSecret">Template Secret</nz-form-label>
                    <nz-form-control [nzErrorTip]="templateIdErrorTpl">
                      <input nz-input formControlName="operatorTemplateSecret" readonly  placeholder="Enter Template Secret" />
                    </nz-form-control>
                  </nz-form-item>

                    <ng-template #templateIdErrorTpl let-control>
  <ng-container *ngIf="control.hasError('required')">Template ID is required</ng-container>
  <ng-container *ngIf="control.hasError('noSpaces')">Spaces are not allowed</ng-container>
</ng-template>


 <nz-form-item nz-col [nzSpan]="5"
                    *ngIf="operator.get('isNewBot')?.value === false && ['VODAFONE','Vi'].includes(operator.get('operatorName')?.value)">
                    <nz-form-label nzFor="operatorTemplateClientId">Client Id</nz-form-label>
                    <nz-form-control [nzErrorTip]="templateIdErrorTpl">
                      <input nz-input formControlName="operatorTemplateClientId"  readonly placeholder="Enter Client Id" />
                    </nz-form-control>
                  </nz-form-item>

                    <ng-template #templateSecretIdErrorTpl let-control>
  <ng-container *ngIf="control.hasError('required')">Template Id is required</ng-container>
  <ng-container *ngIf="control.hasError('noSpaces')">Spaces are not allowed</ng-container>
</ng-template>



                  <nz-form-item nz-col [nzSpan]="5"
                    *ngIf="operator.get('isNewBot')?.value === false && operator.get('operatorName')">
                    <nz-form-label nzFor="botId">Bot Id</nz-form-label>
                    <nz-form-control [nzErrorTip]="botIdErrorTpl">
                      <input nz-input formControlName="operatorBotId"  placeholder="Enter Bot ID" />
                    </nz-form-control>
                  </nz-form-item>



                  <ng-template #botIdErrorTpl let-control>
  <ng-container *ngIf="control.hasError('required')">Bot ID is required</ng-container>
  <ng-container *ngIf="control.hasError('noSpaces')">Spaces are not allowed</ng-container>
</ng-template>

                  <nz-form-item nz-col [nzSpan]="5"
                    *ngIf="operator.get('isNewBot')?.value === false && operator.get('operatorName')">
                    <nz-form-label nzFor="botSecret">Bot Secret</nz-form-label>
                    <nz-form-control [nzErrorTip]="botSecretErrorTpl"> 
                      <input nz-input formControlName="operatorBotSecret" placeholder="Enter Bot Secret" />
                    </nz-form-control>
                  </nz-form-item>

                  <ng-template #botSecretErrorTpl let-control>
  <ng-container *ngIf="control.hasError('required')">Bot Secret is required</ng-container>
  <ng-container *ngIf="control.hasError('noSpaces')">Spaces are not allowed</ng-container>
</ng-template>

                  <nz-form-item nz-col [nzSpan]="4"
                    *ngIf="operator.get('isNewBot')?.value === false && operator.get('operatorName')">
                    <nz-form-label nzFor="botStatus">Bot Status</nz-form-label>
                    <nz-form-control>
                      <nz-select formControlName="operatorBotStatus" style="width: 100%;">
                        <nz-option nzValue="LAUNCHED" nzLabel="LAUNCHED"></nz-option>
                        <nz-option nzValue="PENDING" nzLabel="PENDING"></nz-option>
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>
                </div>

              </nz-card>

              <!-- <nz-card [nzTitle]="operator.get('operatorName')?.value">



                <div nz-row [nzGutter]="6" style="display: flex; flex-wrap: wrap; align-items: center; gap:10px">
                  <nz-form-item nz-col [nzSpan]="5"
                    *ngIf="[''].includes(operator.get('operatorName')?.value)"
                    >

                    <nz-form-control>
                      <nz-radio-group formControlName="isNewBot">
                        <label nz-radio [nzValue]="true">New Bot</label>
                        <label nz-radio [nzValue]="false">Existing Bot</label>
                      </nz-radio-group>
                    </nz-form-control>
                  </nz-form-item>

                  <nz-form-item nz-col [nzSpan]="3">
                    <nz-form-label nzFor="operatorBotId">Traffic Volume</nz-form-label>
                    <nz-form-control>
                      <nz-select formControlName="trafficVolume" nzPlaceHolder="Select Traffic Volume"
                        style="width: 100%;" [ngModel]="100">
                        <nz-option *ngFor="let volume of [10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" [nzValue]="volume"
                          [nzLabel]="volume + '%'"></nz-option>
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>

                <nz-form-item nz-col [nzSpan]="5">
  <nz-form-label nzFor="botId">Bot Id</nz-form-label>
  <nz-form-control [nzErrorTip]="botIdErrorTpl">
    <input nz-input formControlName="operatorBotId" placeholder="Enter Bot ID" />
  </nz-form-control>
</nz-form-item>

<ng-template #botIdErrorTpl let-control>
  <ng-container *ngIf="control.hasError('required')">Bot ID is required</ng-container>
  <ng-container *ngIf="control.hasError('noSpaces')">Spaces are not allowed</ng-container>
</ng-template>


                 <nz-form-item nz-col [nzSpan]="5" *ngIf="operator.get('isNewBot')?.value === false && operator.get('operatorName')?.value!=='VTL'">
  <nz-form-label nzFor="botSecret">Bot Secret</nz-form-label>
  <nz-form-control [nzErrorTip]="botSecretErrorTpl">
    <input nz-input formControlName="operatorBotSecret" placeholder="Enter Bot Secret" />
  </nz-form-control>
</nz-form-item>

<ng-template #botSecretErrorTpl let-control>
  <ng-container *ngIf="control.hasError('required')">Bot Secret is required</ng-container>
  <ng-container *ngIf="control.hasError('noSpaces')">Spaces are not allowed</ng-container>
</ng-template>


                  <nz-form-item nz-col [nzSpan]="4"
                   >
                    <nz-form-label nzFor="botStatus">Bot Status</nz-form-label>
                    <nz-form-control>
                      <nz-select formControlName="operatorBotStatus" style="width: 100%;">
                        <nz-option nzValue="LAUNCHED" nzLabel="LAUNCHED"></nz-option>
                        <nz-option nzValue="PENDING" nzLabel="PENDING"></nz-option>
                      </nz-select>
                    </nz-form-control>
                  </nz-form-item>
                </div>

              </nz-card> -->
            </div>
          </div>

        </form>
      </nz-card>
    </div>
    <div style="margin-top: 2%; display: flex; justify-content: center;" nz-row>
      <nz-space>
        <button *nzSpaceItem nz-button nzType="primary" (click)="submitForm()" [nzLoading]="isDisabled">Submit</button>
        <button *nzSpaceItem nz-button nzType="primary" nzDanger (click)="resetForm()">Reset</button>
      </nz-space>
    </div>

  </form>
</nz-card>